import { v4 as uuidv4 } from "uuid";

import { User } from "@/pages/Public/pages/Login/schema/login";

import { Sender } from "../components/Sender";

/**
 * Computes the current senders list by merging sendingUsers (available app accounts) with configSenders (campaign config).
 * - Senders available in the app: always deactivated: false, active state from config (or false if not in config)
 * - Senders in the campaign config but no longer available in the app: deactivated: true, active state preserved from config
 */
export const computeCurrentSenders = (
	sendingUsers: User[] | undefined,
	configSenders: Sender[] | undefined
): Sender[] => {
	const result: Sender[] =
		sendingUsers?.reduce((acc: Sender[], user: User) => {
			if (user.unipile?.isLoggedIn) {
				const configMatch = configSenders?.find(
					(s: Sender) =>
						s.userId === user.id && s.type === "linkedin" && s.emailAddress === user.email
				);

				acc.push({
					userId: user.id,
					active: configMatch?.active ?? false,
					name: user.firstName + " " + user.lastName,
					type: "linkedin",
					emailAddress: user.email,
					firstName: user.firstName,
					lastName: user.lastName,
					emailType: "primary",
					uuid: uuidv4(),
					deactivated: false,
				});
			}

			if (user.emails?.length && user.emails.length > 0) {
				user.emails.forEach((email) => {
					const configMatch = configSenders?.find(
						(s: Sender) =>
							s.userId === user.id && s.type === "email" && s.emailAddress === email.email
					);

					acc.push({
						userId: user.id,
						active: configMatch?.active ?? false,
						name: user.firstName + " " + user.lastName,
						type: "email",
						emailId: email.id,
						emailAddress: email.email,
						firstName: user.firstName,
						lastName: user.lastName,
						emailType: email.type,
						uuid: uuidv4(),
						deactivated: false,
					});
				});
			}

			return acc;
		}, []) || [];

	// Add ghost senders: senders in the campaign config but no longer available in the app
	if (configSenders) {
		for (const configSender of configSenders) {
			const existsInApp = result.some(
				(s) =>
					s.userId === configSender.userId &&
					s.type === configSender.type &&
					s.emailAddress === configSender.emailAddress
			);

			if (!existsInApp) {
				result.push({
					...configSender,
					uuid: uuidv4(),
					deactivated: true,
				});
			}
		}
	}

	return result;
};
